const EventScript = ({status, startdate, endDate}) =>{
    let thevent

    var current = +new Date();
    var futuredate = endDate.split('-');
    let pastdate = startdate.split('-')
    
    let start = +new Date(pastdate[2] + '-' + pastdate[1] + '-' + pastdate[0]);
    let end = +new Date(futuredate[2] + '-' + futuredate[1] + '-' + futuredate[0]);

    if(status === 1 && current < start){
        thevent = "UPCOMING"
    } else if(status === 1 && (current > start && current < end)){
        thevent = "ONGOING"
    } else if(status === 1 && (current > end)){
        thevent = "COMPLETED"
    } else if(status === 0 && (current < start)){
        thevent = "RESCHEDULED"
    } else if(status === 0 && (current > start)){
        thevent = "CANCELED"
    }
    return thevent
}
export default EventScript